import useMask from 'hooks/useMask';

export const Mask = ({ children, type }) => {
  const { maskedValue } = useMask(type, children);

  return maskedValue;
};
